import { render, staticRenderFns } from "./reportecall.vue?vue&type=template&id=38795388&scoped=true"
import script from "./reportecall.vue?vue&type=script&lang=js"
export * from "./reportecall.vue?vue&type=script&lang=js"
import style0 from "./reportecall.vue?vue&type=style&index=0&id=38795388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38795388",
  null
  
)

export default component.exports